import { Navigation, PackageCheck, AlertTriangle, Flag } from "lucide-react";
import { STATUS, initials, timeAgo, fmtTime } from "./courierMapUtils";

const ProgressBar = ({ p }) => {
  if (!p?.total) return <div className="text-[11px] text-zinc-400 font-mono">Brak trasy na dziś</div>;
  const done = Math.round((p.done / p.total) * 100);
  const skipped = Math.round((p.skipped / p.total) * 100);
  return (
    <div data-testid="courier-progress">
      <div className="flex items-center justify-between text-[11px] font-mono mb-1">
        <span className="text-zinc-700 font-bold">{p.done}/{p.total} dostarczone</span>
        <span className="text-zinc-400">{p.pending} pozostało{p.skipped ? ` · ${p.skipped} awizo` : ""}</span>
      </div>
      <div className="h-1.5 rounded-full bg-zinc-100 overflow-hidden flex">
        <div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${done}%` }} />
        <div className="h-full bg-red-400 transition-[width] duration-500" style={{ width: `${skipped}%` }} />
      </div>
    </div>
  );
};

export const CourierList = ({ couriers, selectedId, onSelect }) => {
  if (!couriers.length) {
    return (
      <div data-testid="courier-list-empty" className="p-6 text-center text-sm text-zinc-500">
        Żaden kurier nie udostępnia dziś pozycji. Pozycja pojawi się, gdy kurier zaloguje się w aplikacji na telefonie i zezwoli na lokalizację.
      </div>
    );
  }
  return (
    <div data-testid="courier-list" className="stagger">
      {couriers.map((c) => {
        const s = STATUS[c.status] || STATUS.offline;
        const sel = c.user_id === selectedId;
        return (
          <button key={c.user_id} type="button" onClick={() => onSelect(sel ? null : c.user_id)}
            data-testid={`courier-item-${c.user_id}`}
            className={`w-full text-left px-4 py-3 border-b border-zinc-100 hover:bg-zinc-50 transition-colors ${sel ? "bg-red-50 border-l-4 border-l-brand" : c.idle_alert ? "bg-amber-50/60 border-l-4 border-l-amber-500" : "border-l-4 border-l-transparent"}`}>
            {c.idle_alert && (
              <div data-testid="courier-idle-alert" className="flex items-center gap-1.5 mb-2 text-[11px] font-bold text-amber-800">
                <AlertTriangle className="w-3.5 h-3.5" />Postój {c.idle_min} min w trakcie trasy
              </div>
            )}
            <div className="flex items-center gap-3 mb-2">
              <span className="w-9 h-9 rounded-full text-white flex items-center justify-center text-xs font-black shrink-0" style={{ background: s.color }}>{initials(c.name)}</span>
              <div className="min-w-0 flex-1">
                <div className="font-bold text-sm truncate">{c.name}</div>
                <div className="text-[11px] text-zinc-400 font-mono">{c.updated_at ? timeAgo(c.updated_at) : "nigdy nie wysłał pozycji"}</div>
              </div>
              <span data-testid="courier-status" className={`inline-flex items-center gap-1.5 px-2 h-6 rounded-full ring-1 text-[10px] font-bold uppercase tracking-wider ${s.pill}`}>
                <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />{s.label}
              </span>
            </div>
            <ProgressBar p={c.progress} />
            {c.progress?.eta && (
              <div data-testid="courier-eta" className="flex items-center gap-1 mt-1.5 text-[11px] text-zinc-700">
                <Flag className="w-3 h-3 text-emerald-600" />Koniec ok. <b className="font-mono">{fmtTime(c.progress.eta)}</b>
                <span className="text-zinc-400 font-mono">· {c.progress.pace_min} min/paczka</span>
              </div>
            )}
            <div className="flex items-center justify-between mt-2 text-[11px]">
              <span className="flex items-center gap-1 text-zinc-500 truncate">
                {c.progress?.next_address ? <><PackageCheck className="w-3 h-3 shrink-0" /><span className="truncate">Następna: {c.progress.next_address}</span></> : null}
              </span>
              {c.speed_kmh != null && c.status !== "offline" && (
                <span className="flex items-center gap-1 font-mono text-zinc-600 shrink-0"><Navigation className="w-3 h-3" />{Math.round(c.speed_kmh)} km/h</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};
